import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiError } from './api-error';

@Injectable({
  providedIn: 'root'
})
export class ToastMessageService {

  constructor(
    private messageService: MessageService
  ) { }

  addSuccess(summary: string, detail: string) {
    this.messageService.add({ severity: 'success', summary: summary, detail: detail });
  }

  addError(summary: string, detail: string) {
    this.messageService.add({ severity: 'error', summary: summary, detail: detail });
  }

  addApiError(error: ApiError){
    this.messageService.add({ severity: 'error', summary: "Error: " + error.status, detail: error.message });
  }
}
